import * as brandColors from '../../../../utils/brand-colors';

export default () => ({
  root: { width: '100%' },
  table: { minWidth: 700 },
  rootButtonConfirm: {
    background: '#3f51b5',
    color: 'white',
    margin: '5px',
  },
  rootButtonReject: {
    background: 'lightgray',
    color: 'white',
    margin: '5px',
  },
  noRequests: { textAlign: 'center' },
  noRequestsIcon: {
    color: brandColors.primary.main,
    fontSize: '60px',
  },
});
